import React from "react";
import { createOptions } from "../../utils/utils";
const DropDown = (props) => {
  return (
    <React.Fragment>
      <div className="form-group">
        <label>
          {props.label}
          {props.required ? (
            <span className="mandatory">
              * &nbsp; <span className="error-msg">{props.error}</span>
            </span>
          ) : null}
        </label>
        <select
          className={props.error ? "is-invalid form-control" : "form-control"}
          name={props.name}
          value={props.value}
          onChange={props.onChange}
          disabled={props.disabled || false}
          readOnly={props.disabled || false}
        >
          {createOptions(
            props.list,
            props.valProp,
            props.textProp,
            props.defaultItem
          )}
        </select>
      </div>
    </React.Fragment>
  );
};
export default DropDown;
